import React from "react";
import { Button } from "./ui/button";
import { Download, Printer, FileSpreadsheet } from "lucide-react";
import { downloadFile } from "../lib/api";

export default function ExportButtons({
  endpoint,
  filenameBase,
  extraQuery = "",
}) {
  const q = extraQuery
    ? extraQuery.startsWith("?")
      ? extraQuery
      : `&${extraQuery}`
    : "";
  const csvUrl = `${endpoint}?format=csv${q.replace("?", "&")}`;
  const xlsxUrl = `${endpoint}?format=xlsx${q.replace("?", "&")}`;
  return (
    <div className="flex max-w-full flex-wrap items-center gap-2 no-print">
      <Button
        data-testid={`export-xlsx-${filenameBase}`}
        variant="outline"
        size="sm"
        onClick={() => downloadFile(xlsxUrl, `${filenameBase}.xlsx`)}
      >
        <FileSpreadsheet className="w-4 h-4 mr-1.5" /> Excel
      </Button>
      <Button
        data-testid={`export-csv-${filenameBase}`}
        variant="outline"
        size="sm"
        onClick={() => downloadFile(csvUrl, `${filenameBase}.csv`)}
      >
        <Download className="w-4 h-4 mr-1.5" /> CSV
      </Button>
      <Button
        data-testid={`print-${filenameBase}`}
        variant="outline"
        size="sm"
        onClick={() => window.print()}
      >
        <Printer className="w-4 h-4 mr-1.5" /> Print / PDF
      </Button>
    </div>
  );
}
